module.exports = __webpack_public_path__ + "static/media/tcr-logo-square.18dba854.png";